import { get } from 'lodash';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import localStore from 'store';

import APP_PATH from '../constants/paths';
import sessionQuery from '../graphql/sessionQuery';
import LoginForm from '../views/Login/Form';
import { setUser } from '../data/user/actions';
import { hasRole } from '../utilities/user';
import PingLoginForm from '../views/Login/PingForm';
import pingUrlQuery from '../graphql/pingUrlQuery';
import USER from '../constants/appUser';
import MaintenancePage from './MaintenancePage';

const Login = props => {
  const {
    client, history, signInUser, pingEnabled, maintenanceStatusEnabled,
  } = props;
  const [error, setError] = useState('');

  const handleSubmit = useCallback(event => {
    event.preventDefault();
    const { username, password } = event.target;

    client
      .query({
        query: sessionQuery,
        variables: { username: username.value, password: password.value },
      })
      .then(({ data }) => {
        const err = get(data, 'session.error');
        if (err) {
          throw Error(err);
        }
        const accessToken = get(data, 'session.accessToken');
        if (!accessToken) {
          throw Error('Unexpected error');
        }
        const user = get(data, 'session.viewer.user');

        if (hasRole('admin', 'roles')(user)) {
          signInUser(user);
          localStore.set('jwt', accessToken);
          history.push(APP_PATH.BASE);
        } else {
          throw Error('You are not authorized to view this page.');
        }
      })
      .catch(err => {
        setError(err.message);
      });
  }, [client, history, signInUser]);

  const callPingUrl = useCallback(() => {
    const user = USER.APP;

    client
      .query({
        query: pingUrlQuery,
        variables: {
          redirect_uri: window.location.origin + APP_PATH.REDIRECT_URL,
          user_type: 'ADMIN',
          app_name: user,
        },
      })
      .then(({ data }) => {
        window.location = data.pingUrl.url;
      })
      .catch(() => {
        setError('Error while calling Ping');
      });
  }, [client]);

  if (maintenanceStatusEnabled) {
    return <MaintenancePage />;
  }

  if (pingEnabled === '') {
    return null;
  }
  if (pingEnabled) {
    return <PingLoginForm onSubmit={callPingUrl} />;
  }
  return <LoginForm error={error} onSubmit={handleSubmit} />;
};

Login.propTypes = {
  client: PropTypes.shape({
    query: PropTypes.func,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  signInUser: PropTypes.func.isRequired,
  pingEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  maintenanceStatusEnabled: PropTypes.bool,
};

Login.defaultProps = {
  pingEnabled: false,
  maintenanceStatusEnabled: false,
};

const mapDispatchToProps = dispatch => ({
  signInUser: user => {
    dispatch(setUser(user));
  },
});

export default compose(
  withApollo,
  withRouter,
  connect(null, mapDispatchToProps)
)(Login);
